import * as React from 'react';
import useSearch from '../hooks/useSearch';
import { LoopResults, IsEmpty, IsNotEmpty } from './searchResults';
export { LoopResults, IsEmpty, IsNotEmpty };
export const Input = ({ ...rest }) => {
    const { value, onChange, onKeyUp, onOpenDropdown } = useSearch();
    return (React.createElement("input", Object.assign({}, rest, { type: rest.type || 'search', value: value, onKeyUp: onKeyUp, onChange: onChange, onFocus: onOpenDropdown, "data-testid": "search-input" })));
};
Input.displayName = 'Search.Input';
//# sourceMappingURL=search.js.map